import React from 'react';

import { HubIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <HubIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useCompanyHub = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		analyticsName: Products.ATLAS_HUB,
		...options,
	});
